import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useQuery } from '@apollo/client'
import { Controller } from 'react-hook-form'

import { injectIntl } from 'react-intl'
import camelCase from 'lodash/camelCase'

import AntDropdown from 'components/AntDropdown'
import FormItem from 'components/Form/Item'

import { ROOM_CHAIR_QUERY } from './graphql'

const mapStateToProps = (state, ownProps) => ({
  initialValue: ownProps.initialValue || state.providersFilter.filters.seatingPlans,
})

const EventRoom = (props) => {
  const {
    intl,
    initialValue,
    room,
  } = props

  const {
    loading,
    data: {
      roomLayout = [],
    } = {},
  } = useQuery(ROOM_CHAIR_QUERY)

  if (loading) {
    return null
  }

  let options = roomLayout

  if (room) {
    options = options.filter(seating => room[camelCase(seating.id)] > 0)
  }

  const dropdownOptions = options.map(({ id }) => ({
    id: id,
    text: intl.formatMessage({ id: `shared.roomType.${camelCase(id)}` }),
  }))

  const initialSelectedValue = dropdownOptions.find(option => option.id === initialValue)?.id || dropdownOptions[0].id

  return (
    <FormItem
      label="&nbsp;"
      showErrorsOf="numberOfPersons"
    >
      <Controller
        name="roomType"
        defaultValue={initialSelectedValue}
        render={({
          field: { onChange, onBlur, value, name, ref },
        }) => (
          <AntDropdown
            className="contact-request-form__room-type"
            ref={ref}
            segments={[
              {
                name: 'roomType',
                type: 'icons',
                iconPrefix: 'seating',
                options: dropdownOptions,
                currentValue: value,
              },
            ]}
            useNativeSelectOnMobile={true}
            onChange={(values) => onChange(values.roomType)}
            onBlur={onBlur}
          />
        )}
      />
    </FormItem>
  )
}

EventRoom.propTypes = {
  intl: PropTypes.object.isRequired,
  initialValue: PropTypes.string,
  room: PropTypes.object,
}

export default injectIntl(connect(mapStateToProps)(EventRoom))
